module.exports = __webpack_public_path__ + "static/media/gry-edukacyjne-dla-11-latka-12-latka.91cb070f.png";